import PressReleaseCard, { PressReleaseCardProps } from "./PressReleaseCard";

export { PressReleaseCard, PressReleaseCardProps };

export default PressReleaseCard;
